import { render, staticRenderFns } from "./HighlightCustomer.vue?vue&type=template&id=07e848ea&scoped=true&"
import script from "./HighlightCustomer.vue?vue&type=script&lang=js&"
export * from "./HighlightCustomer.vue?vue&type=script&lang=js&"
import style0 from "./HighlightCustomer.vue?vue&type=style&index=0&id=07e848ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e848ea",
  null
  
)

export default component.exports